/**
 * CL-PROPERTY-OS-002C3A — Synchronous + remount-safe verification email send guard.
 * Persists only a cooldown timestamp (no PII).
 */

import { VERIFICATION_RESEND_COOLDOWN_MS } from "./portalEmailVerificationModel";

const SESSION_COOLDOWN_KEY = "portal_verification_resend_at";

let sendInFlight = false;

export function readVerificationResendCooldownAt() {
  if (typeof sessionStorage === "undefined") return 0;
  const raw = sessionStorage.getItem(SESSION_COOLDOWN_KEY);
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

export function writeVerificationResendCooldownAt(timestampMs = Date.now()) {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(SESSION_COOLDOWN_KEY, String(timestampMs));
}

export function clearVerificationResendCooldownAt() {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(SESSION_COOLDOWN_KEY);
}

export function canSendVerificationEmailNow(nowMs = Date.now()) {
  const lastSentAt = readVerificationResendCooldownAt();
  if (sendInFlight) return false;
  if (!lastSentAt) return true;
  return nowMs - lastSentAt >= VERIFICATION_RESEND_COOLDOWN_MS;
}

export function tryAcquireVerificationSendLock() {
  if (sendInFlight) return false;
  sendInFlight = true;
  return true;
}

export function releaseVerificationSendLock() {
  sendInFlight = false;
}

export function markVerificationEmailSent(nowMs = Date.now()) {
  writeVerificationResendCooldownAt(nowMs);
}
